<template>
  <v-data-table :headers="headers" :items="items" hide-actions>
    <template #items="{ item }">
      <td>
        <div>{{ item.channel }}</div>
        <template v-if="item.refKeys.length">
          <div v-for="refKey in item.refKeys" :key="refKey" class="primary--text">{{ refKey }}</div>
        </template>
        <div v-else class="primary--text">-</div>
      </td>
      <td>{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      headers: [
        { value: 'channel', text: this.$t('login_channel'), sortable: false },
        { value: 'timestamp', text: this.$t('login_date'), sortable: false }
      ]
    }
  },
  computed: {
    items() {
      return ['My Allianz', 'Healthy Living', 'AAGI'].map((channel) => {
        if (!this.user) {
          return { channel }
        }

        if (channel === 'My Allianz') {
          const { my_allianz_member_data } = this.user
          const refKeys = my_allianz_member_data.oa_ref_key || []
          const timestamp = my_allianz_member_data.registered_timestamp
          return { channel, refKeys, timestamp }
        }

        if (channel === 'AAGI') {
          const { aagi_member_data } = this.user
          const refKeys = aagi_member_data.oa_ref_key || []
          const timestamp = aagi_member_data.registered_timestamp
          return { channel, refKeys, timestamp }
        }

        if (channel === 'Healthy Living') {
          const { health_living_member_data } = this.user
          const refKeys =
            health_living_member_data.oa_ref_key ||
            (health_living_member_data.healthy_living_user_id
              ? [health_living_member_data.healthy_living_user_id]
              : [])
          const timestamp = health_living_member_data.registered_timestamp
          return { channel, refKeys, timestamp }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/my-allianz/LoginInfo/index.vue